@if (mortgageCalculationService.showAccordion()) {
    <div class="border ap-padding-3 ap-margin-top-3">
        <ng-container [ngTemplateOutlet]="summary"></ng-container>
    </div>
} @else {
    <ng-container [ngTemplateOutlet]="summary"></ng-container>
}

<ng-template #summary>
    <ap-content key="mortgage-calculation.disclaimer.intro"></ap-content>

    <ul class="ap-margin-bottom-0 ap-margin-top-3">
        <li>
            @if (storeService.isCalculatingMaxMortgage) {
                {{ 'mortgage-calculation.disclaimer.loading-interest' | apContent }}
                <ap-spinner
                    [visuallyHiddenLabel]="true"
                    class="ap-margin-bottom-1"
                    loadingText="{{ 'mortgage-calculation.spinner.loading' | apContent }}"
                    readyText="{{ 'mortgage-calculation.spinner.ready' | apContent }}"
                    state="loading"
                    [size]="'xsmall'"
                    [icon]="true"
                ></ap-spinner>
            } @else {
                {{
                    'mortgage-calculation.disclaimer.interest'
                        | apContent: { interestRate: this.mortgageDetails?.assumption?.interest | number: '1.2-2' : 'nl' }
                }}
            }
        </li>
        <li>
            {{ getAmortisationTypeKey() | apContent }}
        </li>
        <li>
            {{ 'mortgage-calculation.disclaimer.duration' | apContent: { durationInYears: getFixedRatePeriodKey() | apContent } }}
        </li>
        <li>
            {{ 'mortgage-calculation.disclaimer.energy-label' | apContent: { energyLabel: getEnergyLabelKey() | apContent } }}
        </li>
    </ul>
</ng-template>
